import { render, staticRenderFns } from "./QuestionsForm.vue?vue&type=template&id=50bea946&scoped=true"
import script from "./QuestionsForm.vue?vue&type=script&lang=js"
export * from "./QuestionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bea946",
  null
  
)

export default component.exports